import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CircleLoader,
  LogoLoader,
  NewTab,
} from "../../../components";
import IntegratedInternalDb from "./IntegratedSearchTabs/IntegratedInternalDb";
import IntegratedCareerBuilder from "./IntegratedSearchTabs/IntegratedCareerBuilder";
import IntegratedMonster from "./IntegratedSearchTabs/IntegratedMonster";
import { useSelector } from "react-redux";

const extractJobTitleKeywords = (jobTitle = "") =>
  jobTitle
    .replace(/["()]/g, "")
    .split(/\b(?:AND|OR|NOT)\b/i)
    .map((k) => k.trim())
    .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

const IntegratedSearchResults = ({
  togggleSearchApplicant,
  iDBQuery,
  cBQuery,
  monsterQuery,
}) => {
  const { loading, totalApplicantsCount,totalApplicantsData, careerBuilder, monster } = useSelector(
    (state) => state.internalDbES
  );
  const { total: CBTotal } = careerBuilder;
  const { total: mTotal } = monster;
  const [showResumeButton, setShowResumeButton] = useState(true);
  const [careerBuilderQuery, setCareerBuilderQuery] = useState(cBQuery);
  const [monsterTabQuery, setMonsterTabQuery] = useState(monsterQuery);
  const [internalDBQuery, setInternalDBQuery] = useState(iDBQuery);
  const handleCareerBuilderQueryChange = (newQuery) => {
    setCareerBuilderQuery(newQuery);
  };
  const handleMonsterTabQueryChange = (newQuery) => {
    setMonsterTabQuery(newQuery);
  };
  const handleInternalDBQueryChange = (newQuery) => {
    setInternalDBQuery(newQuery);
  };
  // Keywords Highlighting
  const getCurrentSearchKeywords = (source) => {
    switch (source) {
      case 1: {
        const keywordsSkills = iDBQuery?.payload?.query.skills || [];
        const rawKeywordString = iDBQuery?.payload?.query?.keywords || "";
        const jobTitle = iDBQuery?.payload?.query?.jobTitle || ""
        const titleWords = extractJobTitleKeywords(jobTitle);

        const extra = rawKeywordString
          .replace(/["()]/g, "") // ← removes ( ) and "
          .split(/\b(?:AND|OR|NOT)\b/i) // split on AND / OR / NOT
          .map((k) => k.trim())
          .filter((k) => k.length > 0);

        return [...new Set([...keywordsSkills, ...extra, ...titleWords])];
        break;
      }

      case 2: {
        const jobTitle = cBQuery?.payload?.query?.JobTitle || "";
        const keywords =
          cBQuery?.payload?.query?.Keywords?.replace(
            /\band not\s+\S+/gi,
            ""
          )
            .replace(/[()]/g, "") // remove parentheses
            .match(/"[^"]+"|\S+/g)  // keep quoted text as single word
            ?.map((w) => w.replace(/"/g, "")) // remove quotes
            .filter(
              (w) => !/^(and|or|not|and\s+not|not\s+or)$/i.test(w) // SAME filter
            ) || [];

        const titleWords = extractJobTitleKeywords(jobTitle);
        return [...new Set([...keywords, ...titleWords])];
      }

      case 3: {
        const jobTitle = monsterQuery?.payload?.query?.JobTitle || monsterQuery?.payload?.query?.qrjt || "";
        const skillsArray = monsterQuery?.payload?.query?.Skills || [];
        const queryQ = monsterQuery?.payload?.query?.q || "";

        const titleWords = jobTitle
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

        const qWords = queryQ
          .replace(/["()]/g, "")
          .split(/\b(?:AND|OR|NOT)\b/i)
          .map((k) => k.trim())
          .filter((k) => k.length > 0 && !/^(and|or|not)$/i.test(k));

        return [...new Set([...skillsArray, ...titleWords, ...qWords])];
      }

      default:
        return [];
    }
  };

  //console.log(getCurrentSearchKeywords(3))

  const integratedMenus = [
    {
      title: "Internal DB",
      page: (
        <IntegratedInternalDb
          iDBQuery={internalDBQuery}
          onIDBQueryChange={handleInternalDBQueryChange}
          showResumeButton={showResumeButton}
          keywords={getCurrentSearchKeywords(1)}
          source={1}
        />
      ),
      type: "main",
       value:(
          totalApplicantsData ? totalApplicantsCount :  <div><span><CircleLoader /></span></div>
      ),
      //   id: "accountdetails_getaccountdetails",
    },
    {
      title: "Career Builder",
      page: (
        <IntegratedCareerBuilder
          cBQuery={careerBuilderQuery}
          onCBQueryChange={handleCareerBuilderQueryChange}
          showResumeButton={showResumeButton}
          keywords={getCurrentSearchKeywords(2)}
          source={2}
        />
      ),
      type: "main",
     value: (
         careerBuilder.tableResponse ? CBTotal : <div><span><CircleLoader /></span></div>
      ),
      //   id: "accountdetails_allaccounts",
    },
    {
      title: "Monster",
      page: (
        <IntegratedMonster
          monsterQuery={monsterTabQuery}
          onMonsterQueryChange={handleMonsterTabQueryChange}
          showResumeButton={showResumeButton}
          keywords={getCurrentSearchKeywords(3)}
          source={3}
        />
      ),
      type: "main",
       value: (
           monster.tableResponse ? mTotal: <div><span><CircleLoader /></span></div>
      ),
      //   id: "accountdetails_allaccounts",
    },
  ];

  return (
    <div className="flex flex-col  h-full py-2 overflow-hidden">
      <Button
        icon={"west"}
        title={"Integrated Result"}
        variant="text"
        color="black"
        className="!px-0 font-semibold self-start"
        onClick={togggleSearchApplicant}
      />
      <div className="flex flex-1 my-3 overflow-hidden">
        <NewTab
          tabs={integratedMenus}
          color="black"
          activeColor="primary"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="integrated-search-results"
        />
      </div>
      <Backdrop isOpen={loading} zIndex={52}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default IntegratedSearchResults;
